import React from 'react';
import {Text} from 'react-native';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import LabelBanner from '../LabelBanner';

storiesOf('base', module).add('LabelBanner', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>LabelBanner</Heading>
        <Spacer size={16} />
        <Text>
          A basic <Code>{'<LabelBanner />'}</Code> can be rendered simply by
          passing values to the <Code>label</Code> and <Code>heading</Code>{' '}
          props.
        </Text>
        <Spacer size={16} />
        <LabelBanner label="Label Text" heading="A headline" />
        <Spacer size={10} />
        <Code>{'label="Label Text"'}</Code>
        <Code>{'heading="A headline"'}</Code>
        <Spacer size={16} />
        <Text>
          More complex <Code>{'<LabelBanner />'}</Code>s can be rendered by
          passing any number of variations for the content as{' '}
          <Code>children</Code> to the component.
        </Text>
        <Spacer size={16} />
        <LabelBanner label="Label Text" heading="A headline">
          <Text>
            Eam in alii possit. Sed ne diam nihil. Mei omittam iracundia eu. Ut
            duo vivendo ponderum phaedrum, ea mei erant feugiat. Qui at regione
            alienum blandit, posse tamquam voluptatibus qui ne.
          </Text>
        </LabelBanner>
      </FlexView>
      <FlexView>
        <Spacer size={24} />
        <Heading level={2}>Specifying an alertLevel</Heading>
        <Spacer size={16} />
        <Text>
          <Code>{'<LabelBanner />'}</Code> also respects the{' '}
          <Code>alertLevel</Code> prop.
        </Text>
        <Spacer size={16} />
        <LabelBanner
          label="Label Text"
          heading="A headline"
          alertLevel="error"
        />
        <Spacer size={10} />
        <Code>{'alertLevel="error"'}</Code>
      </FlexView>
      <FlexView>
        <Spacer size={24} />
        <Heading level={2}>Competency-themed Banners</Heading>
        <Spacer size={16} />
        <Text>
          <Code>{'<LabelBanner />'}</Code> also respects the{' '}
          <Code>useCompetency</Code> prop to use competency-based theme colors.
        </Text>
        <Spacer size={16} />
        <LabelBanner
          label="Label Text"
          heading="A headline"
          useCompetency={true}
        />
        <Spacer size={10} />
        <Code>{'useCompetency={true}'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
